/** Stable date/time formatting for SSR + client (avoids hydration mismatches). */

export const APP_TZ = "America/Phoenix";
export const APP_LOCALE = "en-US";

/** Calendar date YYYY-MM-DD in America/Phoenix. */
export function todayIsoPhoenix(now = new Date()): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: APP_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);
}

export function addDaysIso(isoDate: string, days: number): string {
  const [y, m, d] = isoDate.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d + days));
  const yyyy = dt.getUTCFullYear();
  const mm = String(dt.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(dt.getUTCDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

/** Format a service calendar date (YYYY-MM-DD) for display. */
export function formatServiceDate(
  isoDate: string,
  style: "full" | "short" | "weekday" | "monthDay" = "full",
): string {
  const [y, m, d] = isoDate.split("-").map(Number);
  if (!y || !m || !d) return isoDate;
  // Noon UTC avoids DST edge flips for date-only values.
  const dt = new Date(Date.UTC(y, m - 1, d, 19, 0, 0));

  if (style === "weekday") {
    return new Intl.DateTimeFormat(APP_LOCALE, {
      weekday: "short",
      timeZone: APP_TZ,
    })
      .format(dt)
      .toUpperCase();
  }
  if (style === "monthDay") {
    return new Intl.DateTimeFormat(APP_LOCALE, {
      month: "short",
      day: "numeric",
      timeZone: APP_TZ,
    }).format(dt);
  }
  if (style === "short") {
    return new Intl.DateTimeFormat(APP_LOCALE, {
      weekday: "short",
      month: "short",
      day: "numeric",
      timeZone: APP_TZ,
    }).format(dt);
  }
  return new Intl.DateTimeFormat(APP_LOCALE, {
    weekday: "long",
    month: "long",
    day: "numeric",
    timeZone: APP_TZ,
  }).format(dt);
}

export function formatDateTime(iso: string): string {
  const dt = new Date(iso);
  if (Number.isNaN(dt.getTime())) return iso;
  return new Intl.DateTimeFormat(APP_LOCALE, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: APP_TZ,
  }).format(dt);
}

export function formatTime(iso: string): string {
  const dt = new Date(iso);
  if (Number.isNaN(dt.getTime())) return iso;
  return new Intl.DateTimeFormat(APP_LOCALE, {
    hour: "numeric",
    minute: "2-digit",
    timeZone: APP_TZ,
  }).format(dt);
}
